<template>
    <article>
        <h1>Boomerang2D</h1>
        <h3>2017 - Present</h3>

        <section>
            <div class="links">
                <p>
                    <a href="https://www.boomerang2d.com/" target="_blank">Visit the Promo Site</a> |
                    <a href="https://assetstore.unity.com/packages/templates/systems/boomerang-2d-framework-164608"
                       target="_blank">Unity Asset Store Entry</a>
                </p>
            </div>

            <div class="one-column">
                <div class="youtube-iframe-wrapper">
                    <iframe class="real-youtube-container"
                            width="560" height="315"
                            src="https://www.youtube.com/embed/CQTwr4zUfbo"
                            title="Boomerang 2D Trailer"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                    >
                    </iframe>
                </div>

                <p>
                    Boomerang 2D is a Visual Building-Block approach to building Pixel Perfect 2D games in Unity
                    without code. Content is built using a variety of Custom Editors.
                </p>
                <p>
                    Toolkits are made up of common pre-built game elements that you can place into your Unity
                    scene. A simple drag and drop and you're done... unless you want something unique or
                    specific to your needs. Then you either just have to wait and hope the toolkit's developers
                    make it for you, or you're skilled enough to scour through thousands and thousands of lines
                    of code and figure out where to put your special functionality.
                </p>
                <p>
                    Frameworks are systems that streamline the development of a complex application, while
                    creating rules and a structure for all the various elements that make up that application.
                    Boomerang 2D gives you that structure without limiting what you can do.
                </p>
                <p>
                    Instead of using a toolkit to attach a Jetpack script that someone else wrote and only works
                    with a limited predefined set of configurations, you should be using a Framework that lets
                    you easily create that Jetpack with your own configurations, controls, functionality, and
                    customization from the ground-up. With Boomerang 2D, you can do exactly that, and without
                    writing any code at all.
                </p>
            </div>

            <h2>The Actor Studio</h2>
            <div class="two-columns">
                <div>
                    <img src="../assets/page-boomerang2d/screenshot1.png" alt="Actor Studio Screenshot">
                </div>
                <div>
                    <p>
                        Using a robust set of configurations, quickly and easily create all sorts of Interactive
                        Objects, including your Player Character, Enemies, Moving Platforms, Projectiles, Doors, and
                        more.
                    </p>

                    <p>
                        Manage your Actor's behaviors easily with a visual Finite State Machine. For each state, you
                        have complete control over the behavior, transitions into other states, animations, sound
                        effects, and game events that execute every time the state is transitioned into.
                    </p>

                    <p>
                        Boomerang 2D ships with a handful of State Behaviors that cover most cases, but if you need
                        something unique to your project, creating your own state behavior is easy and quick. Just
                        write the behavior class and drop it in the correct folder, and it will immediately be
                        integrated into the Visual Editor.
                    </p>
                </div>
            </div>

            <h2>Tileset Studio</h2>
            <div class="two-columns">
                <div>
                    <img src="../assets/page-boomerang2d/screenshot2.png" alt="Tileset Studio Screenshot">
                </div>

                <div>
                    <p>
                        Create Tilesets quickly and easily with support for a variety of collision shapes,
                        animations, prebuilt stamps, and brushes.
                    </p>
                </div>
            </div>

            <h2>Map Editor</h2>
            <div class="two-columns">
                <div>
                    <img src="../assets/page-boomerang2d/screenshot3.png" alt="Map Editor Screenshot">
                </div>

                <div>
                    <p>
                        Using the tiles created in the Tileset Studio, build your maps for your game. Add Tiles,
                        Stamps, Actors, and even Prefabs to your levels. Maps also use Views, which allow you to
                        control the camera behavior and background music. Trigger regions can also be added,
                        allowing you to execute events based on the properties of Actors who enter them.
                    </p>
                </div>
            </div>

            <h2>HUD Editor and Bitmap Fonts</h2>
            <div class="two-columns">
                <div>
                    <img src="../assets/page-boomerang2d/screenshot5.png" alt="HUD Editor Screenshot">
                    <img src="../assets/page-boomerang2d/screenshot4.png" alt="Bitmap Font Editor Screenshot">
                </div>

                <div>
                    <p>
                        Build reusable HUD Layouts for Dialog Boxes, Inventory Menus, and more. Boomerang 2D ships
                        with a handful of HUD Elements, and new ones can be easily written and integrated into the
                        interface. If you prefer to use Unity's build-in UI system, you can do that, too!
                    </p>

                    <p>Bitmap fonts can be created with a font atlas and assigning regions to characters. These
                        fonts can then be used in the HUD elements.</p>
                </div>
            </div>
        </section>

        <h2>About the Development of Boomerang 2D</h2>
        <h3>Unity, C#, JSON</h3>

        <section>
            <div class="links">
                <p><a href="https://github.com/Garmichael/Boomerang2D" target="_blank">Boomerang 2D Source Code on
                    Github</a></p>
            </div>

            <div class="one-column">
                <p>
                    Boomerang 2D is a plug-in asset for Unity with custom editors that define JSON files. When running,
                    the game will reference these JSON files to control behavior. It takes care of the most common
                    aspects of a 2D game including audio management, state machines, collisions, map building, save file
                    management, and object pooling.
                </p>

                <p>
                    The code base is over 30,000 lines of code, over 400 classes, and took three years to develop.
                </p>

                <p>
                    The framework is designed to be as robust as possible, and so it required careful consideration of
                    how systems should be designed and architected. For example, designing the Finite State Machine for
                    actors meant that I had to consider and come up with a solution that allowed developers to control
                    any state's behavior, conditions that allow states to transition into one another, and assign
                    properties, sound effects, animations, and collisions per state -- and to do it all with a system
                    that was easy to use with a visual input system and required no coding. Every system in the
                    framework - from Tilesets and Maps to Actors and HUDS - evolved from a series of decisions that
                    covered as many use-cases as possible, while also not being restricted to any use-case in
                    particular.
                </p>

                <p>
                    Boomerang 2D is capable of recreating most existing 2D games like Super Mario Bros, Legend of Zelda,
                    Metroid, Hollow Knight, etc. Out of the box, it's not quite robust enough to handle something like
                    Sonic the Hedgehog since it uses a very specialized character controller that binds Sonic to
                    splines, but the framework has hooks that will allow highly customized behavior to be written and
                    easily injected into it. Making sure that content and behavior could be written in a traditional way
                    and still used within the framework was important, and coming up with a system that allowed this was
                    challenging.
                </p>

                <p>

                </p>

            </div>
        </section>
    </article>
</template>

<script>
    export default {
        name: "Boomerang2D"
    }
</script>